module.exports = __webpack_public_path__ + "static/media/oberflex-frenefr101-1200x2490.6fcce932.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-frenefr101-1200x2490.jpg
// module id = 1020
// module chunks = 37